<template>
    <div class="standard sidebar">
        <div class="ui secondary vertical menu"
            data-step="1"
            data-position='right'
            data-intro="Welcome to Admin">

            <nav>
                <a href="#">
                    <img class="ui image"
                        :src="'/images/'+$store.state.provider.service_config.logo_img"
                    >
                </a>
                <a class="hamburger hamburger--spin" @click="toggle_menu()">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </a>
            </nav>
            <div class="ui divider"></div>

            <div class="nav-menu">
                <router-link :to="{name: 'converters'}" class="item">
                    <i class="icons">
                        <i class="book large icon"></i>
                        <span> Converters </span>
                    </i>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
        },
        data() {
            return {
            }
        },
        computed: {
        },
        watch: {
            '$route'(to, from) {
                this.menu_active()

                if (
                    (767 > $(window).width()) &&
                    ($(".nav-menu").css("display") == "block")
                ) {
                    this.toggle_menu()
                }
            },
        },
        mounted() {
            this.menu_active()

            $(window).resize(() => {
                var wdth = $(window).width()
                var nav_menu_display = $(".nav-menu").css("display")
                if (nav_menu_display == 'none' && wdth > 767) {
                    $(".nav-menu").css("display", "block")
                }
            })
        },
        methods: {
            menu_active() {
                $(".nav-menu a.item").each(() => {
                    $(this).removeClass("active")
                    if (window.location.href.includes(this.href) ) {
                        $(this).addClass("active")
                    }
                })
            },
            toggle_menu() {
                $("body").toggleClass("overflow")
                $(".hamburger").toggleClass("active")
                $(".nav-menu").stop().slideToggle(300)
            },
        },
    }
</script>


<style lang="scss">
    @import "../../../assets/stylesheets/sidebar.scss";
</style>
